/* web/app/components/layout/main/header/search-form/search-form.scss */
button {
  background: none;
  border: none;
}
::ng-deep .searchBarDialogPanel .mat-mdc-dialog-container {
  border-radius: 0;
}
/*# sourceMappingURL=search-form.css.map */
